<div
  #viewport
  class="esn-scroll__viewport"
  tabindex="0"
  role="region"
  [attr.aria-label]="label()"
  (scroll)="measure()"
>
  <div #content><ng-content /></div>
</div>

@if (overflowing()) {
  <div class="esn-scroll__rail" aria-hidden="true" (pointerdown)="jumpTo($event)">
    <div class="esn-scroll__track"></div>
    <div class="esn-scroll__fill" [style.height.px]="fillHeight()"></div>
    <svg
      class="esn-scroll__handle"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="10 14 17.3064 19.6742"
      [style.transform]="'translate(-50%, ' + handleTop() + 'px)'"
      (pointerdown)="startDrag($event)"
      (pointermove)="drag($event)"
      (pointerup)="endDrag($event)"
      (pointercancel)="endDrag($event)"
    >
      <path
        d="M22.4432 17.2492L22.453 17.2551L22.4637 17.261L26.3065 19.4182L26.2528 23.8254V23.8488L26.3065 28.2561L22.4637 30.4133L22.453 30.4192L22.4432 30.425L18.6532 32.674L14.8631 30.425L14.8534 30.4192L14.8426 30.4133L10.9999 28.2561L11.0536 23.8488V23.8254L10.9999 19.4182L14.8426 17.261L14.8534 17.2551L14.8631 17.2492L18.6532 15.0002L22.4432 17.2492Z"
        fill="var(--esn-space-violet-80)"
        stroke="var(--esn-space-violet)"
        stroke-width="2"
        stroke-miterlimit="1.30541"
      />
    </svg>
  </div>
}
